module.exports = function(value) {
	if(value && value.toLocaleString)
		return value.toLocaleString();
	return value;
};